import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { style } from './pdp-tabs.style.js'
import './pdp-tab.js'
import type { CSCPdpTab } from './pdp-tab.js'

@customElement('csc-pdp-tabs')
export class CSCPdpTabs extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  private get tabs(): CSCPdpTab[] {
    return [...this.children].filter((el): el is CSCPdpTab => el.tagName === 'CSC-PDP-TAB')
  }

  override render() {
    const tabs = this.tabs

    return html`
      <cse-tabs>
        ${tabs.map(tab => html`
          <cse-tab panel=${tab.slot} ?disabled=${tab.disabled}>${tab.label}</cse-tab>
        `)}
        ${tabs.map(tab => html`
          <cse-tab-panel slot="content" name=${tab.slot}>
            <slot name=${tab.slot}></slot>
          </cse-tab-panel>
        `)}
      </cse-tabs>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-pdp-tabs': CSCPdpTabs
  }
}
